const licenceTypes = [
   { value: 'NATIONAL', name: 'Nacional' },
   { value: 'PROVINCIAL', name: 'Provincial' },
];

export default licenceTypes;
